import Layout from '@/layouts/Layout'
// 基础路由
export const baseRouters = [{
  path: '/login',
  component: () => import('@/pages/login/index'),
  hidden: true,
},
{
  path: '/403',
  component: () => import('@/pages/403'),
  hidden: true,
},
{
  path: '/404',
  component: () => import('@/pages/404'),
  hidden: true,
},

{
  path: '/preview',
  component: () => import('@/pages/previewleasecontract'),
  hidden: true,
},
{
  path: '/',
  component: Layout,
  redirect: '/welcome',
  hidden: true,
  children: [
    {
      path: '/welcome',
      component: () => import('@/pages/Welcome'),
      meta: { title: '首页' },
      name: 'welcome',
      hidden: true,
    },
    {
      path: '/noPermission',
      component: () => import('@/pages/noPermission'),
      meta: { title: '首页' },
      name: 'noPermission',
      hidden: true,
    },
    {
      path: '/carResourceNoPermission',
      component: () => import('@/pages/carResource/noPermission.vue'),
      hidden: true,
    },
  ],
}]
